export const environment = {
    production: false,
    apiEndpoint: "https://stageapi.medify.net",
    adminApiVersion: "/admin/api/v1",
    frontApiVersion: "/front/api/v1",
    frontApiVersion1 : "/front/api/v2",
  };